import * as React from 'react'
import {
  Slide,
  styled,
  Box,
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  DialogActions,
  Stack,
  Button,
  TextField
} from '@mui/material'
import { TransitionProps } from '@mui/material/transitions'
import { useTranslation } from 'react-i18next'
import CloseIcon from '@mui/icons-material/Close'
import { ProgressPencil } from 'mdi-material-ui'
import { useMutation } from 'react-query'
import PositionedSnackbar from '@/@core/components/message'

const Grading = React.forwardRef(
  (
    props: {
      value: any
    },
    ref
  ) => {
    const { t } = useTranslation()
    const [radioValue, setRadioValue] = React.useState<string>('')

    const [textValue, setTextValue] = React.useState<string>('')
    const radioList = [
      {
        title: t('drug-responsive'),
        value: false,
        key: 'drug response'
      },
      {
        title: t('pathogenic'),
        value: false,
        key: 'pathogenic'
      },
      {
        title: t('pathogenicity'),
        value: false,
        key: 'likely pathogenic'
      },
      {
        title: t('unknown-significance'),
        value: false,
        key: 'uncertain significance'
      },
      {
        title: t('possibly-benign'),
        value: false,
        key: 'likely benign'
      },
      {
        title: t('benign'),
        value: false,
        key: 'benign'
      },
      {
        title: t('null'),
        value: false,
        key: ''
      }
    ]

    React.useEffect(() => {
      if (props.value.user_classification) {
        setRadioValue(props.value.user_classification)
      }
    }, [props.value])

    React.useImperativeHandle(ref, () => {
      return {
        textValue,
        radioValue
      }
    })

    return (
      <Box>
        <FormControl>
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setRadioValue(e.target.value)
            }}
            value={radioValue}
          >
            {radioList.map((item) => {
              return (
                <FormControlLabel
                  value={item.key}
                  control={<Radio />}
                  label={item.title}
                  key={item.key}
                />
              )
            })}
          </RadioGroup>
        </FormControl>

        <TextField
          id="outlined-multiline-static"
          multiline
          rows={4}
          fullWidth
          value={textValue}
          onChange={(e) => {
            setTextValue(e.target.value)
          }}
          sx={{
            marginTop: '10px'
          }}
        />
      </Box>
    )
  }
)

export default Grading
